module.exports = __webpack_public_path__ + "static/media/PayementEIPScreen.306a3bd2.png";